import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "course-detail"
};
var _hoisted_2 = {
  class: "top"
};
var _hoisted_3 = {
  class: "left-func"
};
var _hoisted_4 = {
  class: "center"
};
var _hoisted_5 = {
  class: "center-header"
};
var _hoisted_6 = {
  class: "center-header-info"
};
var _hoisted_7 = {
  class: "center-header-info-img"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  key: 0,
  class: "kind"
};
var _hoisted_10 = {
  key: 1,
  class: "subject"
};
var _hoisted_11 = {
  key: 2,
  class: "tutorialName"
};
var _hoisted_12 = {
  key: 3,
  class: "tutorialVersion"
};
var _hoisted_13 = {
  class: "center-header-info-box"
};
var _hoisted_14 = {
  class: "center-header-info-box-top"
};
var _hoisted_15 = {
  class: "title-box"
};
var _hoisted_16 = ["src"];
var _hoisted_17 = {
  class: "title"
};
var _hoisted_18 = {
  key: 1,
  class: "label"
};
var _hoisted_19 = {
  class: "data-item"
};
var _hoisted_20 = {
  class: "value"
};
var _hoisted_21 = {
  class: "data-item"
};
var _hoisted_22 = {
  class: "value"
};
var _hoisted_23 = {
  class: "center-header-info-box-top-collect"
};
var _hoisted_24 = ["src"];
var _hoisted_25 = {
  class: "center-header-info-box-content"
};
var _hoisted_26 = {
  class: "info-line"
};
var _hoisted_27 = {
  class: "left"
};
var _hoisted_28 = {
  class: "info-label"
};
var _hoisted_29 = {
  class: "right"
};
var _hoisted_30 = {
  class: "info-label"
};
var _hoisted_31 = {
  class: "info-line"
};
var _hoisted_32 = {
  class: "left"
};
var _hoisted_33 = {
  class: "info-label gray"
};
var _hoisted_34 = {
  class: "info-line"
};
var _hoisted_35 = {
  class: "left"
};
var _hoisted_36 = {
  key: 0,
  class: "info-label gray"
};
var _hoisted_37 = {
  class: "right"
};
var _hoisted_38 = {
  class: "center-header-info-box-bottom"
};
var _hoisted_39 = {
  key: 1,
  class: "empty-btn"
};
var _hoisted_40 = {
  class: "center-main"
};
var _hoisted_41 = {
  class: "tab-box"
};
var _hoisted_42 = {
  class: "recommend-box"
};
var _hoisted_43 = {
  key: 0
};
var _hoisted_44 = {
  key: 1,
  style: {
    "opacity": "0.25",
    "text-align": "center"
  }
};
var _hoisted_45 = {
  key: 1,
  class: "course-loading"
};
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getCurriculumDetail, getCurriculumAboutList, collectLesson, useLesson, getNotAuth } from '@/api/resources.js';
import { MessagePlugin } from 'tdesign-vue-next';
import Introduce from './card/Introduce';
import LessonMenu from './card/LessonMenu';
import Team from './card/Team';
import openVipDialog from '@/components/openVip';
import lessonRecommendItem from './card/lessonRecommendItem';
import { escape2Html } from '@/util/util';
import notAuth from './notAuth';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var dataObj = ref(null);
    var fullscreenLoading = ref(true);
    var serverLogoDgefault = require('@/assets/course/big.svg');
    var dialogVisible = ref(false);
    var type = ref({
      1: '校级课程',
      2: '区域课程',
      3: '平台课程'
    });
    var typeName = ref({
      nation: '国家课程',
      specialty: '特色课程'
    });
    var thousands = function thousands() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var str = num.toString();
      var reg = str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, '$1,');
    };
    var starOff = require('@/assets/course/collect.svg');
    var starOn = require('@/assets/course/collect-active.svg');
    var collectLoading = ref(false);
    var quoteLoading = ref(false);
    var itemData = ref({});
    var visible = ref(false);
    var activeKey = ref(0);
    var tabList = ref([{
      componentTag: 'LessonMenu',
      label: '课程目录',
      disabled: false
    }, {
      componentTag: 'Introduce',
      label: '课程介绍',
      disabled: false
    }
    /* {
      componentTag: 'Team',
      label: '课程团队',
      disabled: false
    } */]);
    var recommendList = ref([]);
    var accountType = route.query.accountType;
    var isStudent = route.query.isStudent === 'true';
    var notAuthObj = ref({});
    var authVisible = ref(false);
    var getData = function getData() {
      getCurriculumDetail(route.query.id, route.query.source).then(function (res) {
        if (res.data.code === 0) {
          dataObj.value = res.data.data;
          fullscreenLoading.value = false;
        }
      });
      getCurriculumAboutList({
        current: 1,
        size: 10,
        curriculumId: route.query.id
      }).then(function (res) {
        if (res.data.code === 0) {
          recommendList.value = res.data.data.records;
        }
      });
    };
    getData();
    var curriculumClick = function curriculumClick(item) {
      activeKey.value = 0;
      router.push("/curriculumDetail?id=".concat(item.id, "&source=").concat(item.source || 2, "&accountType=").concat(accountType));
    };
    watch(function () {
      return route.query;
    }, function () {
      getData();
    }, {
      deep: true,
      immediate: true
    });
    var collect = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return collectLesson(val.id, val.resourceSource || val.source || val.module || 2);
            case 1:
              res = _context.v;
              if (res.data.code === 0) {
                MessagePlugin.closeAll();
                dataObj.value.isColl ? MessagePlugin.success('收藏成功！') : MessagePlugin.success('取消收藏成功！');
              }
              getData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function collect(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var loadNotAuth = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getNotAuth(id);
            case 1:
              res = _context2.v;
              if (res.data.code === 0) {
                notAuthObj.value = res.data.data;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function loadNotAuth(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var citeClose = function citeClose() {
      authVisible.value = false;
      quoteLoading.value = false;
    };
    var use = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(val) {
        var _notAuthObj$value, _notAuthObj$value2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              itemData.value = val;
              quoteLoading.value = true;
              if (!((val.resourceSource || val.source || val.module === 2) && accountType === '2')) {
                _context3.n = 4;
                break;
              }
              _context3.n = 1;
              return loadNotAuth(val.id);
            case 1:
              if (!((_notAuthObj$value = notAuthObj.value) !== null && _notAuthObj$value !== void 0 && (_notAuthObj$value = _notAuthObj$value.course) !== null && _notAuthObj$value !== void 0 && _notAuthObj$value.length || (_notAuthObj$value2 = notAuthObj.value) !== null && _notAuthObj$value2 !== void 0 && (_notAuthObj$value2 = _notAuthObj$value2.resource) !== null && _notAuthObj$value2 !== void 0 && _notAuthObj$value2.length)) {
                _context3.n = 2;
                break;
              }
              authVisible.value = true;
              _context3.n = 3;
              break;
            case 2:
              _context3.n = 3;
              return loadUse(val.id, val.resourceSource || val.source || val.module || 2, {
                resourceIds: [],
                courseIds: []
              });
            case 3:
              _context3.n = 5;
              break;
            case 4:
              _context3.n = 5;
              return loadUse(val.id, val.resourceSource || val.source || val.module || 2, {
                resourceIds: [],
                courseIds: []
              });
            case 5:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function use(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    var loadUse = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id, type, data) {
        var query, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              query = Object.assign({
                id: id,
                curriculumSource: type
              }, data);
              _context4.n = 1;
              return useLesson(query);
            case 1:
              res = _context4.v;
              if (res.data.code === 0) {
                MessagePlugin.closeAll();
                MessagePlugin.success('引用成功！');
                quoteLoading.value = false;
                getData();
                authVisible.value = false;
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function loadUse(_x4, _x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }();
    var hClose = function hClose() {
      visible.value = false;
    };
    var openVip = function openVip(item) {
      itemData.value = item;
      visible.value = true;
    };
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_tab_panel = _resolveComponent("t-tab-panel");
      var _component_t_tabs = _resolveComponent("t-tabs");
      var _component_t_dialog = _resolveComponent("t-dialog");
      var _component_t_loading = _resolveComponent("t-loading");
      return !fullscreenLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(dataObj.value.name), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        src: dataObj.value.cover || _unref(serverLogoDgefault)
      }, null, 8, _hoisted_8), typeName.value[dataObj.value.resourceTypeDictItemCode] ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(typeName.value[dataObj.value.resourceTypeDictItemCode]), 1)) : _createCommentVNode("", true), dataObj.value.subjectDictItemName && dataObj.value.resourceTypeDictItemCode === 'nation' ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(dataObj.value.subjectDictItemName), 1)) : _createCommentVNode("", true), dataObj.value.tutorialName && dataObj.value.resourceTypeDictItemCode === 'nation' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(dataObj.value.tutorialName), 1)) : _createCommentVNode("", true), dataObj.value.tutorialVersionDictItemName && dataObj.value.resourceTypeDictItemCode === 'nation' ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(dataObj.value.tutorialVersionDictItemName), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_15, [dataObj.value.isVipResource && _unref(accountType) === '2' ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: require('@/assets/vipIcon.svg'),
        style: {
          "margin-right": "8px"
        }
      }, null, 8, _hoisted_16)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_17, _toDisplayString(dataObj.value.name ? _unref(escape2Html)(dataObj.value.name) : '暂无标题'), 1), type.value[dataObj.value.owned] ? (_openBlock(), _createElementBlock("label", _hoisted_18, _toDisplayString(type.value[dataObj.value.owned]), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass(["data-list", {
          hide: dataObj.value.ascription === 2
        }])
      }, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(thousands(dataObj.value.citeCount)), 1), _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "key"
      }, "引用", -1))]), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(thousands(dataObj.value.collCount)), 1), _cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "key"
      }, "收藏", -1))])], 2)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
        src: dataObj.value.isColl === 0 ? _unref(starOn) : _unref(starOff),
        class: "collect-icon",
        alt: "收藏",
        title: "收藏",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return collect(dataObj.value);
        })
      }, null, 8, _hoisted_24)])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(dataObj.value.typeNameStr), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(dataObj.value.ascription === 2 ? dataObj.value.creatorName : dataObj.value.schoolName), 1)])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createTextVNode(_toDisplayString(dataObj.value.ascription === 2 ? '创编人' : '责任编辑') + "：" + _toDisplayString(dataObj.value.creatorName) + " ", 1), dataObj.value.creatorSchool ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("（" + _toDisplayString(dataObj.value.creatorSchool) + "）", 1)], 64)) : _createCommentVNode("", true), _createElementVNode("template", null, [_createTextVNode(" ID: " + _toDisplayString(dataObj.value.uniqueCode), 1)])])])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [dataObj.value.approvalUserName ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createTextVNode(" 审核人：" + _toDisplayString(dataObj.value.approvalUserName) + " ", 1), dataObj.value.approvalUserSchool ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("（" + _toDisplayString(dataObj.value.approvalUserSchool) + "）", 1)], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", {
        class: _normalizeClass(["info-label gray", {
          hide: dataObj.value.ascription === 2 || !dataObj.value.reportTime
        }])
      }, _toDisplayString(dataObj.value.reportTime) + "发布 ", 3)])])]), _createElementVNode("div", _hoisted_38, [!isStudent ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [dataObj.value.hasVipRole && dataObj.value.isVipResource || !dataObj.value.isVipResource || _unref(accountType) !== '2' ? (_openBlock(), _createBlock(_component_t_button, {
        key: 0,
        theme: "primary",
        shape: "round",
        variant: "base",
        class: "link-button",
        loading: quoteLoading.value,
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return use(dataObj.value);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(quoteLoading.value ? '引用中' : '引用课程'), 1)];
        }),
        _: 1
      }, 8, ["loading"])) : (_openBlock(), _createBlock(_component_t_button, {
        key: 1,
        theme: "primary",
        shape: "round",
        variant: "base",
        class: "vip-button",
        loading: quoteLoading.value,
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return openVip(dataObj.value);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[8] || (_cache[8] = [_createTextVNode("开通会员", -1)]));
        }),
        _: 1
      }, 8, ["loading"]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_39)), _createElementVNode("span", {
        class: _normalizeClass(["copyright", {
          hide: dataObj.value.ascription === 2
        }]),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return dialogVisible.value = true;
        })
      }, "版权声明", 2)])])])]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createVNode(_component_t_tabs, {
        value: activeKey.value,
        "onUpdate:value": _cache[4] || (_cache[4] = function ($event) {
          return activeKey.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, function (item, index) {
            return _openBlock(), _createBlock(_component_t_tab_panel, {
              disabled: item.disabled,
              value: index,
              key: index,
              label: item.label
            }, {
              default: _withCtx(function () {
                return [index === 0 ? (_openBlock(), _createBlock(_unref(LessonMenu), {
                  key: 0,
                  dataObj: dataObj.value
                }, null, 8, ["dataObj"])) : _createCommentVNode("", true), index === 1 ? (_openBlock(), _createBlock(_unref(Introduce), {
                  key: 1,
                  dataObj: dataObj.value
                }, null, 8, ["dataObj"])) : index === 2 ? (_openBlock(), _createBlock(_unref(Team), {
                  key: 2,
                  dataObj: dataObj.value
                }, null, 8, ["dataObj"])) : _createCommentVNode("", true)];
              }),
              _: 2
            }, 1032, ["disabled", "value", "label"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["value"])]), _createElementVNode("div", _hoisted_42, [_cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "title"
      }, "相关课程", -1)), recommendList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendList.value, function (item, index) {
        return _openBlock(), _createBlock(_unref(lessonRecommendItem), {
          key: index,
          info: item,
          onClick: function onClick($event) {
            return curriculumClick(item);
          }
        }, null, 8, ["info", "onClick"]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_44, "暂无相关课程"))])])]), _createElementVNode("div", null, [_createVNode(_component_t_dialog, {
        visible: dialogVisible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = function ($event) {
          return dialogVisible.value = $event;
        }),
        header: "版权声明",
        width: "50%",
        footer: false
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[10] || (_cache[10] = [_createElementVNode("p", null, "   本平台上的所有资源均系使用本平台者上传或发布，上传或发布资源者须确保所有作品系其原创或者已征得权利人书面许可或授权转发或使用，如侵犯第三人权利，本公司有权直接删除而不承担任何责任。 ", -1), _createElementVNode("p", null, "    本平台上的所有作品未经权利人书面许可或授权不得转发或使用，否则导致侵犯本公司或他人权利的，由行为人承担法律责任。 ", -1), _createElementVNode("p", null, "   如您认为平台所载资源侵犯您的有关权利，可以联系本公司协助处理，但本平台不因此承担任何责任，相关法律责任由行为人承担。本声明长期有效，欢迎您浏览本平台信息。 ", -1), _createElementVNode("p", null, "本公司联系方式：李得祺   电话：15563859280  邮箱：zhixuehuijiao@163.com", -1), _createTextVNode(" 祝您身体康健、工作/生活愉快! ", -1)]));
        }),
        _: 1
      }, 8, ["visible"])]), visible.value ? (_openBlock(), _createBlock(_unref(openVipDialog), {
        key: 0,
        dialogVisible: visible.value,
        itemData: itemData.value,
        onHClose: hClose
      }, null, 8, ["dialogVisible", "itemData"])) : _createCommentVNode("", true), authVisible.value && _unref(accountType) === '2' ? (_openBlock(), _createBlock(_unref(notAuth), {
        key: 1,
        dialogVisible: authVisible.value,
        itemData: itemData.value,
        accountType: _unref(accountType),
        notAuthObj: notAuthObj.value,
        onLoadUse: loadUse,
        onCiteClose: citeClose
      }, null, 8, ["dialogVisible", "itemData", "accountType", "notAuthObj"])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_45, [_createVNode(_component_t_loading), _cache[11] || (_cache[11] = _createTextVNode(" 加载中... ", -1))]));
    };
  }
};